import { MapData } from '@atom/types/map';

// Excluded assets the server returned for the current shape. A clustered
// response may hide excluded assets inside a cluster, so the count can't be
// trusted and is reported as 0.
export const countExcludedInShape = (
  data: MapData,
  excludedIds: string[],
): number => {
  const { clusters = [], assets = [] } = data;

  if (clusters.length > 0) {
    return 0;
  }

  const excluded = new Set(excludedIds);
  return assets.filter(({ id }) => excluded.has(id)).length;
};

// Drops excluded assets from the map data and lowers the server's asset count
// to match, so every consumer (list, markers, stats, bulk create) sees the
// reduced set.
export const applyExclusions = (
  data: MapData,
  excludedIds: string[],
): MapData => {
  if (excludedIds.length === 0) {
    return data;
  }

  const excluded = new Set(excludedIds);
  const { assets = [], assetsCount = 0 } = data;

  return {
    ...data,
    assets: assets.filter(({ id }) => !excluded.has(id)),
    assetsCount: Math.max(
      0,
      assetsCount - countExcludedInShape(data, excludedIds),
    ),
  };
};
